// external styles
import 'bootstrap-css-only'
import './assets/css/global.css'
import './assets/css/font-awesome-4.7.0/css/font-awesome.min.css'
// js imports
import Vue from 'vue'
import App from './App'
import {router} from './routes/Router'

import AppData from './data/AppData'
import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import api from './services/api.js'
import VueTables from 'vue-tables-2'
import moment from 'Moment'

/* eslint-disable no-new */

Vue.use(VueCookie)
Vue.use(VeeValidate)
Vue.use(VueResource)
Vue.use(VueTables.client)
Vue.config.debug = true

Vue.component('details-link', {
	props: ['id'],
	template: '<button v-on:click="goDetails">View</button>',
	methods: {
		goDetails: function (e) {
			router.push({ path: 'academy/' + this.id })
			e.preventDefault()
		}
	}
})

Vue.component('loading-bar', {
	template: '<div class="loading"><div class="loading-bar"></div><div class="loading-bar"></div><div class="loading-bar"></div><div class="loading-bar"></div><span>Loading</span></div>'
})

Vue.directive('timestamp', {
	inserted: function (el, binding) {
		el.innerText = moment(binding.value).format('LLL')
	}
})

Vue.component('confirm', {
	template: '#confirm-template'
})

// create vm
new Vue({
	el: '#app',
	template: '<App/>',
	router: router,
	store: AppData,
	components: { App }
})

window.api = api
api.getAppVersion()



// WEBPACK FOOTER //
// ./src/main.js